module.exports = __webpack_public_path__ + "au.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/au.svg
// module id = 427
// module chunks = 0